// IE 2026 11 01 / ODOO-350449 (заказ Игоря: номер тижня на осі X теплокарти, як у REPORT2)
// Общий расчёт ISO-8601 недели на фронте — та же формула, что была методом AttrChart.isoWeek; совпадает с pandas Period(..., 'W').weekofyear бэка
// (data_layout2.py — заголовки недель REPORT2 «42W», data_layout_transpose.py — date_Week графика). Неделя — с понедельника, первая неделя года — та,
// где четверг; isoWeekYear — год этой недели (29.12.2025 → 1-я неделя 2026, 01.01.2027 → 53-я неделя 2026).
// Вход: Date (берутся локальные год / месяц / день — как у AttrChart) или строка 'YYYY-MM-DD…'; невалидно — null. Юнит — tests/unit/isoWeek.test.mjs
const RE_YMD = /^(\d{4})-(\d{2})-(\d{2})/

// дата → полночь UTC того же календарного дня (null — невалидно)
function utcDay(d) {
    if (d instanceof Date) return isNaN(d) ? null : new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()))
    const m = RE_YMD.exec(String(d == null ? '' : d))
    if (!m) return null
    const t = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]))
    return isNaN(t) ? null : t
}

// четверг ISO-недели даты — по нему определяются и номер, и год недели
function thursdayOf(d) {
    const t = utcDay(d)
    if (!t) return null
    const day = t.getUTCDay() || 7
    t.setUTCDate(t.getUTCDate() + 4 - day)
    return t
}

// { week, year } ISO-недели даты; невалидно — null
export function isoWeekOf(d) {
    const t = thursdayOf(d)
    if (!t) return null
    const yearStart = new Date(Date.UTC(t.getUTCFullYear(), 0, 1))
    return { week: Math.ceil((((t - yearStart) / 86400000) + 1) / 7), year: t.getUTCFullYear() }
}

// номер ISO-недели 1…53 (невалидно — null)
export function isoWeek(d) {
    const w = isoWeekOf(d)
    return w ? w.week : null
}

// год ISO-недели (на стыке лет может отличаться от календарного года даты; невалидно — null)
export function isoWeekYear(d) {
    const w = isoWeekOf(d)
    return w ? w.year : null
}
